






























































































































































































































































































































































































































































































































































































































import { Mixins, Component } from 'vue-property-decorator';
import { AxPage } from '@/mixins';
import * as I from '@/interfaces';
import * as E from '@/interfaces';

interface ModeValue {
  code: number;
  text: string;
}

interface AxPort {
  acuID: number;
  extID: number;
  portID: number;
  boardType: string;
}

class State {
  tabConfig: number;
  accessZoneCode: number;
  zoneName: string;
  acuID: number;
  name: string;
  ip: string;
  itemStatus: string;
  deviceType: E.EDeviceType;
  listAccubankOper: I.AccuBankWiegandOperation[];
  listAccuBankWiegand: I.AccuBankWiegandConfig[];
  operation: I.AccuBankWiegandOperation;
  config: I.AccuBankWiegandConfig;
  axWiegand: I.AxWiegandData;
  axSensor: I.AxSensorData;
  listAxRelay: I.AxRelayData[];
  listAxSensor: I.AxSensorData[];
  listAxWiegand: I.AxWiegandData[];
  axBoardType: string;
  constructor() {
    this.tabConfig = 0;
    this.accessZoneCode = 0;
    this.zoneName = '';
    this.acuID = 0;
    this.ip = '';
    this.name = '';
    this.itemStatus = 'New';
    this.deviceType = E.EDeviceType.AX_ACU;
    this.listAccubankOper = [];
    this.listAccuBankWiegand = [];
    this.listAxRelay = [];
    this.listAxSensor = [];
    this.listAxWiegand = [];
    this.axBoardType = '';
    this.operation = {
      acuID: 0,
      readerID: 0,
      portIdUpper: 0,
      portIDLower: 0,
      scheduleDoor: 0,
      scheduleAPB: 0,
      schedulePIN: 0,
      relay1Time: 30,
      relay2Time: 0,
      doorInputHeldOpenTime: 600,
      tamperInputHeldOpenTime: 0,
      buttonInputHeldOpenTime: 600,
      doorForceOpenAlert: false,
      fireOperation: E.EOperationOnFire.OPEN,
      doorOpenBeep: false,
      apbMode: false,
      updateFlag: 'I'
    };
    this.config = {
      acuID: 0,
      readerID: 0,
      portIdUpper: 0,
      portIDLower: 0,
      portUse: true,
      purpose: E.EPurPose.ENTRANCE,
      operMode: E.EOperationMode.ID_ONLY,
      doorInputNo: 0,
      doorInputType: E.ENoNc.NO,
      tamperInputNo: 0,
      tamperInputType: E.ENoNc.NO,
      buttonInputNo: 0,
      buttonInputType: E.ENoNc.NO,
      relay1No: 0,
      relay1Type: E.ERelayMode.AUTH_OK,
      relay2No: 0,
      relay2Type: E.ERelayMode.NOT_USE,
      updateFlag: 'I'
    };
    this.axSensor = {
      axAcuID: 0,
      extId: 0,
      portId: 0,
      portUse: true,
      inputType: E.ENoNc.NO,
      connectionUse: true,
      releaseMode: E.ESensorReleaseMode.RELEASE_AUTO,
      linkedRelayBoardID: 0,
      linkedRelayBoardPort: 0,
      schedule: 0,
      detectionDelayTime: 0,
      redetectionTime: 0,
      relayMode: E.ERelayMode.NOT_USE,
      updateFlag: 'I'
    };
    this.axWiegand = {
      axAcuID: 0,
      extID: 0,
      portID: 0,
      portUse: true,
      linkNO: 0,
      purpose: E.EPurPose.ENTRANCE,
      operationMode: E.EOperationMode.ID_ONLY,
      doorInputUse: true,
      doorConnectionUse: true,
      doorInputType: E.ENoNc.NO,
      tamperInputUse: true,
      tamperConnectionUse: true,
      tamperInputType: E.ENoNc.NO,
      buttonInputUse: true,
      buttonConnectionUse: true,
      buttonInputType: E.ENoNc.NO,
      relayType1ST: E.ERelayMode.NOT_USE,
      relayTime1ST: 0,
      relayType2ND: E.ERelayMode.NOT_USE,
      relayTime2ND: 0,
      scheduleDoor: 0,
      scheduleAPB: 0,
      schedulePIN: 0,
      sensingTimeDoor: 0,
      sensingTimeTamper: 0,
      sensingTimeButton: 0,
      doorForceOpen: false,
      fireOperation: E.EOperationOnFire.OPEN,
      doorBeep: false,
      antipassMode: false,
      updateFlag: 'I'
    };
  }
}

class AcuPanel {
  listAcu: I.AcuDetail[];
  listZone: I.AxZone[];
  zoneCode: number;
  constructor() {
    this.listAcu = [];
    this.listZone = [];
    this.zoneCode = 0;
  }
}

@Component
export default class Acu extends Mixins(AxPage) {
  pageInfo: I.AcuPageInfo | undefined;
  state: State = new State();
  acuPanel: AcuPanel = new AcuPanel();
  listAcuType = [
    { deviceType: E.EDeviceType.ACCU_BANK_5400, name: 'AccuBank5400' },
    { deviceType: E.EDeviceType.ACCU_BANK_5800, name: 'AccuBank5800' },
    { deviceType: E.EDeviceType.AX_ACU, name: 'AxACU' }
  ];

  listOperation: ModeValue[] = [
    { code: 0, text: 'ID Only' },
    { code: 1, text: 'ID And Pin' }
  ];

  listRelayMode: ModeValue[] = [
    { code: 0, text: 'Not Use' },
    { code: 1, text: 'AUTH OK' },
    { code: 2, text: 'AUTH Error' },
    { code: 3, text: 'Entrance' },
    { code: 4, text: 'Exit' }
  ];

  listFireMode: ModeValue[] = [
    { code: 0, text: '사용 안 함' },
    { code: 1, text: '열림' },
    { code: 2, text: '닫힘' }
  ];

  listAxSensorMode: ModeValue[] = [
    { code: 0, text: '릴레이 없음' },
    { code: 0, text: '릴레이 자동 켜짐' },
    { code: 0, text: '관리자에 의해 릴레이 끔' },
    { code: 0, text: '관리자에 의해 릴레이 켬/끔' }
  ];

  listSchedule: I.UserScheduleList[] = [];

  get listRelay() {
    const list: ModeValue[] = [];
    list.push({ code: 0, text: '사용 안 함' });
    if (this.state.deviceType === E.EDeviceType.ACCU_BANK_5400) {
      for (let i = 1; i <= 8; i++) list.push({ code: i, text: i.toString() });
      return list;
    } else if (this.state.deviceType === E.EDeviceType.ACCU_BANK_5800) {
      for (let i = 1; i <= 16; i++) list.push({ code: i, text: i.toString() });
      return list;
    } else {
      return list;
    }
  }

  get listSensor() {
    const list: ModeValue[] = [];
    list.push({ code: 0, text: '사용 안 함' });
    if (this.state.deviceType === E.EDeviceType.ACCU_BANK_5400) {
      for (let i = 1; i <= 16; i++) list.push({ code: i, text: i.toString() });
      return list;
    } else if (this.state.deviceType === E.EDeviceType.ACCU_BANK_5800) {
      for (let i = 1; i <= 24; i++) list.push({ code: i, text: i.toString() });
      return list;
    } else {
      return list;
    }
  }

  async prepare() {
    const baseData = await this.getBaseData();
    if (baseData) {
      this.pageInfo = baseData;
      this.listSchedule = this.pageInfo.listSchedule;
      const list = this.getZoneList();
      if (list) {
        this.acuPanel.listZone = list;
        this.state.accessZoneCode = list[0].code;
        this.state.zoneName = list[0].name;
        this.acuPanel.zoneCode = list[0].code;
      }
    }
  }

  async getBaseData() {
    const result = await this.API.call.config.acuPageInfo();
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }
  onListGroupChanged(zone?: I.AxZone) {
    if (!this.pageInfo || !zone) return;
    if (this.acuPanel.listAcu) {
      this.acuPanel.listAcu = this.pageInfo.listAcu.filter(x => x.zoneCode === zone.code);
    }
  }

  onListItemChanged(item?: I.AcuDetail) {
    this.state = new State();
    if (item) {
      const item2 = JSON.parse(JSON.stringify(item));
      this.state.accessZoneCode = item2.zoneCode;
      this.state.acuID = item2.acuID;
      this.state.name = item2.name;
      this.state.ip = item2.ip;
      this.state.listAccuBankWiegand = item2.listAccuBankWiegandConfig;
      this.state.deviceType = item2.deviceType;
      this.state.listAccubankOper = item2.listAccubankOper;
      this.state.itemStatus = 'Update';
      this.state.listAxRelay = item2.listAxRelay;
      this.state.listAxSensor = item2.listAxSensor;
      this.state.listAxWiegand = item2.listAxWiegand;
    } else {
    }
  }

  onListAddClicked(group: I.AxZone) {
    if (!this.pageInfo) return;
    this.state = new State();
    this.state.accessZoneCode = group.code;
    this.state.zoneName = group.name;
    // this.state.listAcu = this.pageInfo.listAcu.filter(x => x.zoneCode === group.code);
  }

  RowClick(item: any) {
    if (this.isAccubank) {
      const config = item as I.AccuBankWiegandConfig;
      this.state.config = config;
      const oper = this.state.listAccubankOper.find(
        x => x.acuID === config.acuID && x.readerID === config.readerID
      );
      if (oper) {
        this.state.operation = oper;
      }
    } else {
      const config = item as AxPort;
      this.state.axBoardType = config.boardType;
      const sensor = this.state.listAxSensor.find(
        x => x.axAcuID === config.acuID && config.extID === x.extId
      );
      const wiegand = this.state.listAxWiegand.find(
        x => x.axAcuID === config.acuID && x.extID === config.extID
      );
      if (sensor) {
        this.state.axSensor = sensor;
      }
      if (wiegand) {
        this.state.axWiegand = wiegand;
      }
    }
  }

  onSaveClicked() {
    /* const { code, name, itemStatus } = this.dataItem.state;
    if (itemStatus === E.ItemStatus.None) return;

    const updateFlag =
      itemStatus === E.ItemStatus.New ? E.EUpdateFlag.Insert : E.EUpdateFlag.Update;

    if (!this.dataItem.state.code) {
      await this.showErrorModal('오류', '코드를 입력 해주세요.');
      return;
    } else if (!this.dataItem.state.name) {
      await this.showErrorModal('오류', '이름을 입력 해주세요.');
      return;
    }

    const title = '확인';
    const message =
      itemStatus === E.ItemStatus.New
        ? '입력한 아이템을 추가할까요?'
        : '선택한 아이템을 수정할까요?';
    const buttons = ['네', '아니오'];


    const confirm = await this.showConfirmModal(title, message, buttons);
    if (confirm !== 0) return;

    this.setLoading(true);

    const codeType = this.dataItem.state.codeType.code;
    const result = await this.updateItem({ code, name, codeType, updateFlag });

    this.setLoading(false);
    if (!result) return;

    this.onUpdated(result, updateFlag);
    */
  }

  onDeleteClicked() {
    console.log('c');
  }
  onClearClicked() {
    console.log('c');
  }

  get isAccubank() {
    return this.state.deviceType === E.EDeviceType.ACCU_BANK_5400 ||
      this.state.deviceType === E.EDeviceType.ACCU_BANK_5800
      ? true
      : false;
  }

  get listWiegand() {
    if (this.isAccubank) {
      return this.state.listAccuBankWiegand;
    } else {
      const list: AxPort[] = [];
      this.state.listAxSensor.forEach(item => {
        list.push({
          acuID: item.axAcuID,
          extID: item.extId,
          portID: item.portId,
          boardType: '센서'
        });
      });
      this.state.listAxWiegand.forEach(item => {
        list.push({
          acuID: item.axAcuID,
          extID: item.extID,
          portID: item.portID,
          boardType: '위겐드'
        });
      });
      this.state.listAxRelay.forEach(item => {
        list.push({
          acuID: item.acuID,
          extID: item.extID,
          portID: item.portID,
          boardType: '릴레이'
        });
      });
      console.log(list);
      return list;
    }
  }

  get headers() {
    if (this.isAccubank) {
      return [
        { text: '확장 보드 ID', value: 'portIdUpper', align: 'start' },
        { text: '포트 ID', value: 'readerID', align: 'start' },
        { text: '사용', value: 'portUse', align: 'start' }
      ];
    } else {
      return [
        { text: '확장 보드 ID', value: 'extID', align: 'start' },
        { text: '포트 ID', value: 'portID', align: 'start' },
        { text: '보드 종류', value: 'boardType', align: 'start' }
      ];
    }
  }
}
